<template>
    <div>
        <el-row align="center" type="flex" class="row" v-loading="loading">
            <el-col class="vertical-center confirm-receiving-email-of-user" style="height: 100%">
                <h1 id="confirm_send_email_title" v-if="isEmailWasSend">{{$t('register.confirmEmailSent')}}</h1>
                <div class="row confirm-email-message" v-if="isEmailWasSend" style="margin-top: 15px">
                    <h3 style="padding-right: 10px; margin: 0px">{{$t('register.emailWasSentTo')}}</h3>
                    <h3 style="text-align: center!important; color: #4B86E8; text-decoration: underline; padding-right: 10px; margin: 0px">
                        {{registeredEmail}}</h3>
                    <h3 style="margin: 0px">{{$t('register.youRegister')}}</h3>
                </div>
                <h3 id="email_was_send_message" v-if="isEmailWasSend">
                    {{$t('register.pleaseCheckEmailToConfirmPassword')}}</h3>

                <el-row v-if="!isEmailWasSend" style="text-align: center; padding-top: 20px">
                    <h3 style="text-align: center">{{$t('register.pleaseClickBackButton')}}</h3>
                </el-row>

                <el-row style="text-align: center; padding-top: 20px">
                    <el-button id="resend_email_button" v-if="isEmailWasSend" @click="reSendEmail">
                        {{$t('register.sendEmailAgainButton')}}
                    </el-button>
                    <el-button id="back_button" @click="backToRegisterPage">{{$t('register.backButton')}}</el-button>
                </el-row>

            </el-col>

        </el-row>
    </div>
</template>

<script>
    import UserApi from "../../api/user/UserApi";
    import AlertService from "../../service/alert.service";

    export default {
        name: "ConfirmSendEmailToRegisterAddress",

        data() {
            return {
                loading: false,
                message: "",
                userCode: null,
                registeredEmail: null,
                registeredPassword: null,
                isEmailWasSend: false,
            }
        },

        created() {
            console.log("End user code: " + this.$route.query.endUserCode)
            let endUserCode = this.$route.query.endUserCode;
            this.userCode = endUserCode;

            UserApi.isEmailWasSendAndEndUserIsNotActive(endUserCode).then(result => {
                console.log("Result" + result)
                if (result) {
                    this.registeredEmail = result;
                    this.isEmailWasSend = true;
                } else {
                    this.$router.push({path: "/register"})
                }
            })
        },

        methods: {
            backToRegisterPage() {
                this.$router.push({path: "/register"})
            },

            reSendEmail() {
                this.loading = true,
                    UserApi.reSendEmail(this.userCode).then(result => {
                        console.log("Sending email to confirm...")
                        console.log(result)
                        if (result) {
                            this.loading = false;
                            AlertService.success(this.$t("register.resendEmailSuccessfully"))
                        } else {
                            AlertService.error(this.$t("register.resendEmailFailed"))
                        }

                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .confirm-receiving-email-of-user {
        margin-right: 25%;
        margin-left: 25%;
    }

    .confirm-email-message {
        padding-left: 50px
    }

    #email_was_send_message {
        text-align: left;
        padding-left: 50px
    }

    #confirm_send_email_title {
        font-weight: bold;
        text-align: left;
        font-size: 30px;
        margin-bottom: 0;
        padding-left: 50px
    }

    #resend_email_button {
        width: 220px;
        background-color: #4B86E8;
        color: white
    }

    #back_button {
        width: 130px;
    }

    @media screen and (max-width: 1024px) {
        .confirm-receiving-email-of-user {
            margin-right: 0;
            margin-left: 0
        }
    }

    @media only screen and (max-width: 450px) {
        #confirm_send_email_title {
            font-size: 25px !important;
            padding-left: 0;
            text-align: center;
        }

        .confirm-email-message {
            padding-left: 0;
        }

        .confirm-receiving-email-of-user {
            width: 100%;
            padding-left: 0 !important;
            margin-right: 0;
            margin-left: 0;
        }

        #resend_email_button {
            width: 100%;
            display: inline-block;
            margin-bottom: 10px;
            background-color: #4B86E8;
            color: white

        }

        #back_button {
            width: 100%;
            display: inline-block;
            margin-left: 0;
        }

        #email_was_send_message {
            padding-left: 0
        }

    }

</style>
